import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { getBackgroundColor } from 'src/utils';
import { isEqualString } from 'src/utils/strings';

const TotalAmountCell: FC<GridCellProps> = (props: GridCellProps) => {
  const { setActualizedAmountData, toggleExpand } = useViewCheckbook();
  const { value, displayValue } = useGridCellDisplayValue(props);
  const isJournalEntry = isEqualString(props.dataItem.action, 'Journal Entry');

  const handleClick = useCallback(() => {
    if (!isJournalEntry) {
      setActualizedAmountData((prev) =>
        [...prev].map((item) => {
          if (item?.rowId === props.dataItem.rowId) {
            item.expanded = !props.dataItem.expanded;
          }
          return item;
        })
      );
      toggleExpand();
    }
  }, [
    isJournalEntry,
    props.dataItem.expanded,
    props.dataItem.rowId,
    setActualizedAmountData,
    toggleExpand,
  ]);

  return (
    <GridCellBase
      {...props}
      style={getBackgroundColor(value)}
      title={displayValue}
      className="!text-right"
    >
      <button
        onClick={handleClick}
        className={`${!isJournalEntry ? 'text-link underline' : ''} cursor-pointer`}
      >
        <span>{displayValue}</span>
      </button>
    </GridCellBase>
  );
};

export default TotalAmountCell;
